import { requestJson } from "../core/http.js";

export class CoachClient {
  constructor(apiBase, request = requestJson) {
    this.apiBase = apiBase;
    this.request = request;
  }

  get available() {
    return Boolean(this.apiBase);
  }

  buildPayload({ phase = "photo", result = null, imageDataUrl = null }) {
    const payload = { phase, image: imageDataUrl || null };
    if (!result) return payload;
    return {
      ...payload,
      prediction: result.top.id,
      confidence: Number(result.confidence.toFixed(4)),
      probabilities: result.probabilities
    };
  }

  async advise(input) {
    if (!this.available) throw new Error("Guida vocale non configurata");
    const data = await this.request(`${this.apiBase}/api/coach`, {
      method: "POST",
      body: this.buildPayload(input),
      timeoutMs: 25000
    });
    return data?.text || "";
  }
}
